
import { useState, useEffect } from 'react';
import translations from '../../text/get-started-translations.json';
import language from '../../utils/LanguageSettings';

export interface CookiesBarProps {
}

const CookiesBar: React.FC<CookiesBarProps> = () => {
  const [isVisible, setIsVisible] = useState(false);
  const pageTranslations = translations[language]; 

  const getCookie = (name: string): string | null => {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  useEffect(() => {
    if (!getCookie('disclaimerAccepted')) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    const date = new Date();
    date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
    const expires = '; expires=' + date.toUTCString();
    document.cookie = 'disclaimerAccepted=true' + expires + '; domain=.nowtv.now.com; path=/';
    setIsVisible(false);
  };

  const isZh = language === 'zh';
  const policyUrl = isZh
    ? '/wp-content/uploads/cookiespolicy/Cookies_Policy_ZH.pdf'
    : '/wp-content/uploads/cookiespolicy/Cookies_Policy_EN.pdf';

  return (
    <div className={`cookiesBar ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="container">
        <p>
          {pageTranslations.cookiesBarText1}
          <a href={policyUrl} target="_blank" rel="noopener noreferrer">
            {pageTranslations.cookiesBarText2}
          </a>
          {pageTranslations.cookiesBarText3}
        </p>
        <button type="button" className="btn primary" onClick={handleAccept}>
          {pageTranslations.cookiesBarButton}
        </button>
      </div>
    </div>
  );
};

export default CookiesBar;
